import { image } from "framer-motion/client"
import { Link } from "lucide-react"
const navitems = [
  {
    title: "SEO",
    Element: [
      {
        subtitle: "Improve Your Organic Search",
        image:"/images/h1.svg",
        links: [
          {
            "title": "Learn More About SEO",
            "link": "/seo"
          },
          {
            "title": "SEO Services",
            "link": "/seo/services/"
          },
          {
            "title": "Local SEO",
            "link": "/seo/services/local-seo"
          },
          {
            "title": "On Page SEO",
            "link": "/seo/services/on-page-seo"
          },
          {
            "title": "Technical SEO",
            "link": "/seo/services/technical-seo"
          },
          {
            "title": " SEO Consulting",
            "link": "/seo/services/seo-consulting"
          },
          {
            "title": "SEO Audit",
            "link": "/seo/services/seo-audit"
          },
          {
            "title": "Off Page SEO",
            "link": "/seo/services/off-page-seo"
          },
          {
            "title": "App Store Optimization",
            "link": "/app-store-optimization"
          },
          {
            "title": "Ecommerce SEO",
            "link": "/seo/services/ecommerce-seo"
          }
        ]
      },
      {
        subtitle: "Increase Website Authority",
        image:"/images/h2.svg",

        links: [
          {
            "title": "Link Building Services",
            "link": "/link-building-services"
          },
          {
            "title": "Guest Posting Services",
            "link": "/guest-posting-services"
          },
          {
            "title": "Article Submission Services",
            "link": "/seo/services/article-submission/"
          },
          {
            "title": "Citation Submission",
            "link": "/seo/services/citation-submissions/ "
          },
          {
            "title": "Blog Commenting Service",
            "link": "/seo/services/blog-commenting/"
          },
          {
            "title": "Content Marketing",
            "link": "/content-marketing-services"
          }
        ]
      },
      {
        subtitle: "Our Free SEO Tools",
        image:"/images/h3.svg",

        links: [
    {
      "title": "Create Backlinks",
      "link": "/seo-tools/backlink-maker"
    },
    {
      "title": "Website SEO Analyzer",
      "link": "/website-seo-analyzer"
    },
    {
      "title": "Free SEO Tools",
      "link": "/seo-tools"
    },
    {
      "title": "Keyword Position Checker",
      "link": "/seo-tools/keyword-position-checker"
    },
    {
      "title": "Google Index Checker",
      "link": "/seo-tools/google-index-checker/"
    },
    {
      "title": "XML Sitemap Generator",
      "link": "/seo-tools/xml-sitemap-generator"
    }
  ]
      },
    ]
  },
  {
    title: "Performance Marketing",
    Element: [
      {
        subtitle: "Generate Quality Leads",
        image:"/images/h4.svg",

      links: [
    {
      "title": "Google Shopping Ads",
      "link": "/google-shopping-ads"
    },
    {
      "title": "Google Ads Service",
      "link": "/google-ads-services"
    },
    {
      "title": "Bing Ads",
      "link": "/google-ads-services"
    },
    {
      "title": "Performance Marketing",
      "link": "/performance-marketing"
    },
    {
      "title": "LinkedIn Marketing",
      "link": "/linkedin-marketing-services-usa"
    },
    {
      "title": "Facebook Marketing",
      "link": "/facebook-advertising-services"
    },
    {
      "title": "Conversion Rate Optimization",
      "link": "/conversion-rate-optimization"
    }
  ]
      },
      {
        subtitle: "Social Media",
        image:"/images/h5.svg",

        links: [
          {
            "title": "Social Media Optimization",
            "link": "/social-media-optimization"
          },
          {
            "title": "Social Media Marketing",
            "link": "/social-media-marketing-services"
          },
          {
            "title": "Twitter Marketing",
            "link": "/twitter-marketing-services"
          },
          {
            "title": "Instagram Marketing",
            "link": "/instagram-marketing-services"
          },
          {
            "title": "Pinterest Marketing Services",
            "link": "/pinterest-marketing-services-usa"
          },
          {
            "title": "Video Marketing",
            "link": "/video-marketing"
          },
          {
            "title": "YouTube Marketing Services",
            "link": "/youtube-marketing-services"
          }
        ]
      },
      {
        subtitle: "Learn About Us",
        image:"/images/h6.svg",

        links: [
          {
            "title": "Case Study",
            "link": "/case-study"
          },
          {
            "title": "Our Clients",
            "link": "/our-client-list"
          },
          {
            "title": "PPC Tools",
            "link": "/blog/40-ppc-tools-for-any-task"
          },
          {
            "title": "PPC Case Study",
            "link": "/google-ads-services"
          },
          {
            "title": "What are PPC Services?",
            "link": "/blog/what-are-ppc-services/"
          },
          {
            "title": "Social Media Management",
            "link": "/blog/social-media-management-everything-you-need-to-know/"
          }
        ]
      },
    ]

  },
  {
    title: "Web Development & UI/UX",

    Element: [
      {
        subtitle: "Web Development Services",
        image:"/images/h7.svg",

      links: [
        {
          "title": "Web Development Services",
          "link": "/web-development-services"
        },
        {
          "title": "Magento Web Development",
          "link": "/magento-web-development-services"
        },
        {
          "title": "Laravel Development Services",
          "link": "/laravel-development-services"
        },
        {
          "title": "PHP Development Services",
          "link": "/custom-php-development-services-company"
        },
        {
          "title": "ASP Dot Net Development Services",
          "link": "/asp-dot-net-development-services"
        }
  ]
      },
      {
        subtitle: "Web Design Services",
        image:"/images/h8.svg",

        links: [
          {
            "title": "Web Design Services",
            "link": "/web-design-services"
          },
          {
            "title": "WordPress Development",
            "link": "/wordpress-development-services"
          },
          {
            "title": "Logo Design",
            "link": "/logo-design-services"
          },
          {
            "title": "Mobile Responsive Website",
            "link": "/mobile-responsive-designing-services"
          },
          {
            "title": "Website Speed Optimization",
            "link": "/seo/services/technical-seo/website-speed-optimization"
          }
        ]
      },
      {
        subtitle: "Learn About Us",
        image:"/images/h9.svg",

        links: [
          
          {
            "title": "SEO Case Studies",
            "link": "/case-study"
          },
          {
            "title": "Client Testimonials",
            "link": "/testimonials"
          },
          {
            "title": "Read Our Super Blogs",
            "link": "/blog"
          },
          {
            "title": "Website Migration Guide",
            "link": "/blog/website-migration-guide-boost-seo"
          },
          {
            "title": "Website Migration Plugins",
            "link": "/blog/free-wordpress-website-migration-plugins"
          }
        ]
      },
    ]

  },
  {
    title: "Our Packages",
    Element: [
      {
        subtitle: "Increase Your Traffic With SEO",
        image:"/images/h10.svg",

      links: [
        {
          "title": "SEO Packages",
          "link": "/seo-packages"
        },
        {
          "title": "Ecommerce SEO Packages",
          "link": "/ecommerce-seo-packages"
        },
        {
          "title": "Local SEO Packages",
          "link": "/local-seo-packages"
        },
        {
          "title": "Guest Posting Service Packages",
          "link": "/guest-posting-service-packages"
        },
        {
          "title": "App Store ASO Packages",
          "link": "/app-store-aso-packages"
        },
        {
          "title": "Link Building Packages",
          "link": "/link-building-packages"
        }
  ]
      },
      {
        subtitle: "Paid & Social Media Marketing",
        image:"/images/h11.svg",

        links: [
          {
            "title": "Online Reputation Management Packages",
            "link": "/orm-packages"
          },
          {
            "title": "PPC Service Packages",
            "link": "/ppc-services-packages"
          },
          {
            "title": "Digital Marketing Packages",
            "link": "/digital-marketing-packages"
          },
          {
            "title": "Facebook Marketing Packages",
            "link": "/facebook-marketing-packages"
          },
          {
            "title": "Social Media Marketing Packages",
            "link": "/social-media-marketing-packages"
          },
          {
            "title": "Conversion Rate Optimization Packages",
            "link": "/cro-packages"
          }
        ]
      },
      {
        subtitle: "Modern Technology Web Development",
        image:"/images/h12.svg",

        links: [
          {
            "title": "Web Development Packages",
            "link": "/web-development-package"
          },
          {
            "title": "Video Marketing Packages",
            "link": "/video-marketing-packages"
          },
          {
            "title": "Content Marketing Packages",
            "link": "/content-marketing-packages"
          }
        ]
      },
    ]

  },
  {
    title: "Tools",
    Element: [
      {
        subtitle: "SEO Analysis and Optimization",
        image:"/images/h13.svg",

      links: [
        {
          "title": "All SEO Tools",
          "link": "/seo-tools"
        },
        {
          "title": "Website SEO Analyzer",
          "link": "/website-seo-analyzer"
        },
        {
          "title": "Keywords Research Tool",
          "link": "/seo-tools/keywords-research-tool"
        },
        {
          "title": "Meta Tags Analyzer",
          "link": "/seo-tools/meta-tags-analyzer/"
        },
        {
          "title": "Code to Text Ratio Checker",
          "link": "/seo-tools/code-to-text-ratio-checker/"
        },
        {
          "title": "Keyword Density Checker",
          "link": "/seo-tools/keyword-density-checker/"
        },
        {
          "title": "Keyword Ranking Checker",
          "link": "/seo-tools/keyword-position-checker/"
        },
        {
          "title": "Keywords Suggestion Tool",
          "link": "/seo-tools/keywords-suggestion-tool/"
        },
        {
          "title": "Mozrank Checker",
          "link": "/seo-tools/mozrank-checker/"
        },
        {
          "title": "Alexa Rank Checker",
          "link": "/seo-tools/alexa-rank-checker/"
        },
        {
          "title": "Online Ping Website Tool",
          "link": "/seo-tools/online-ping-website-tool/"
        },
        {
          "title": "Google Index Checker",
          "link": "/seo-tools/google-index-checker/"
        },
        {
          "title": "Search Engine Spider Simulator",
          "link": "/seo-tools/spider-simulator/"
        }
  ]
      },
      {
        subtitle: "Website Performance and Technical",
        image:"/images/h14.svg",

        links: [
          {
            "title": "Server Status Checker",
            "link": "/seo-tools/server-status-checker/"
          },
          {
            "title": "Page Size Checker",
            "link": "/seo-tools/page-size-checker/"
          },
          {
            "title": "Page Speed Checker",
            "link": "/seo-tools/pagespeed-insights-checker/"
          },
          {
            "title": "Redirect Checker",
            "link": "/seo-tools/www-redirect-checker/"
          },
          {
            "title": "Google Cache Checker",
            "link": "/seo-tools/google-cache-checker/"
          },
          {
            "title": "Google Malware Checker",
            "link": "/seo-tools/google-malware-checker/"
          },
          {
            "title": "Blacklist Lookup",
            "link": "/seo-tools/blacklist-lookup/"
          },
          {
            "title": "Robots.txt Generator",
            "link": "/seo-tools/robots-txt-generator/"
          },
          {
            "title": "XML Sitemap Generator",
            "link": "/seo-tools/xml-sitemap-generator/"
          },
          {
            "title": "URL Rewriting Tool",
            "link": "/seo-tools/url-rewriting-tool/"
          },
          {
            "title": "Online MD5 Generator",
            "link": "/seo-tools/online-md5-generator/"
          },
          {
            "title": "URL Encoder / Decoder",
            "link": "/seo-tools/url-encoder-decoder/"
          }
        ]
      },
      {
        subtitle: "Content and Link Building",
        image:"/images/h15.svg",

        links: [
          {
            "title": "Plagiarism Checker",
            "link": "/seo-tools/plagiarism-checker/"
          },
          {
            "title": "Readability Checker",
            "link": "/seo-tools/readability-checker/"
          },
          {
            "title": "Word Counter",
            "link": "/seo-tools/word-counter/"
          },
          {
            "title": "Article Rewriter",
            "link": "/seo-tools/article-rewriter/"
          },
          {
            "title": "Meta Tag Generator",
            "link": "/seo-tools/meta-tag-generator/"
          },
          {
            "title": "Backlink Generator",
            "link": "/seo-tools/backlink-maker/"
          },
          {
            "title": "Broken Links Finder",
            "link": "/seo-tools/broken-links-finder/"
          },
          {
            "title": "Backlink Checker",
            "link": "/seo-tools/backlink-checker/"
          },
          {
            "title": "Link Analyzer",
            "link": "/seo-tools/link-analyzer-tool/"
          },
          {
            "title": "Website Screenshot Generator",
            "link": "/seo-tools/website-screenshot-generator/"
          },
          {
            "title": "Get Source Code of Webpage",
            "link": "/seo-tools/get-source-code-of-webpage/"
          },
          {
            "title": "Link Price Calculator",
            "link": "/seo-tools/link-price-calculator/"
          },
          {
            "title": "Webpage Screen Resolution Simulator",
            "link": "/seo-tools/webpage-screen-resolution-simulator/"
          },
          {
            "title": "Website Link Count Checker",
            "link": "/seo-tools/website-links-count-checker/"
          }
        ]
      },
      {
        subtitle: "Domain and IP Checker",
        image:"/images/h16.svg",

        links: [
          {
            "title": "Domain Authority Checker",
            "link": "/seo-tools/domain-authority-checker/"
          },
          {
            "title": "Page Authority Checker",
            "link": "/seo-tools/page-authority-checker/"
          },
          {
            "title": "Domain Age Checker",
            "link": "/seo-tools/domain-age-checker/"
          },
          {
            "title": "Domain Hosting Checker",
            "link": "/seo-tools/domain-hosting-checker/"
          },
          {
            "title": "Find DNS Records",
            "link": "/seo-tools/find-dns-records/"
          },
          {
            "title": "My IP Address",
            "link": "/seo-tools/my-ip-address/"
          },
          {
            "title": "Domain into IP Checker",
            "link": "/seo-tools/domain-into-ip/"
          },
          {
            "title": "Class C IP Checker",
            "link": "/seo-tools/class-c-ip-checker/"
          },
          {
            "title": "Whois Checker",
            "link": "/seo-tools/whois-checker/"
          },
          {
            "title": "Suspicious Domain Checker",
            "link": "/seo-tools/suspicious-domain-checker/"
          },
          {
            "title": "What is My Browser",
            "link": "/seo-tools/what-is-my-browser/"
          },
          {
            "title": "Reverse IP Domain Checker",
            "link": "/seo-tools/reverse-ip-domain-checker/"
          },
          {
            "title": "Email Privacy",
            "link": "/seo-tools/email-privacy/"
          }
        ]
      },
    ]
  },
  {
    title: "About Us",
    Element: [
      {
        subtitle: "",
        image:"",
      links: [
        {
          title: "Our Awards",
          link: "/about-us/awards/",
        },
        {
          title: "Who we are",
          link: "/seo-packages",
        },
        {
          title: "Life at W3era",
          link: "/ecommerce-seo-packages",
        },
        {
          title: "Local SEO Packages",
          link: "/local-seo-packages",
        },
        {
          title: "Guest Posting Service Packages",
          link: "/guest-posting-service-packages",
        },
  ]
      },
    
    ]
  },
  {
    title: "Our Work",
    Element: [
      {
        subtitle: "",
        image:"",
      links: [
        { title: "Testimonials", link: "/testimonials" },
        { title: "Case Study", link: "/case-studies" },
        { title: "Our Clients", link: "/our-client-list" },
  ]
      },
    
    ]
  },
  {
    title: "Blogs",
    Link:'/blog/'
    
  },
  {
    title: "Web Story",
    Link:'/web-stories/'
    
  },
  {
    title: "Contact Us",
    Link:'/contact-us/'
    
  },
  {
    title: "Career",
    Link:'/career/'
    
  },
]
export default navitems